import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Chat as ChatIcon, Close as CloseIcon } from '@mui/icons-material';

const ChatLauncher = ({ open, onToggle }) => (
  <Tooltip title={open ? 'Close assistant' : 'Privacy Assistant'} placement="left">
    <IconButton
      onClick={onToggle}
      sx={{
        bgcolor: '#18B89A',
        color: '#04211D',
        width: 56,
        height: 56,
        boxShadow: '0 8px 24px rgba(2, 6, 23, 0.45)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          bgcolor: '#14A88D',
          transform: 'translateY(-2px)',
          boxShadow: '0 10px 28px rgba(2, 6, 23, 0.5)',
        },
      }}
    >
      {open ? <CloseIcon /> : <ChatIcon />}
    </IconButton>
  </Tooltip>
);

export default ChatLauncher;
